<!-- 
语文
课外阅读    task 4    test 1
高频错题    task 2    test 3
单元复习    task 2    test 2
同步习题    task 2    test 1
生词听写    task 2    test 4
课前预习    task 1    test 2
数学

-->
<template>
    <div class="task-list"
         id="tasklist"
         @touchmove="loadMore($event)">
        <div class="myScroll"
             ref="myScroll">
            <headers :title='titles'
                     :is_finish='inApp'></headers>
            <template>
                <div :class="['tab','clearfix',{'bb':tabType==2}]"
                     v-if="sids.length>0">
                    <p :class="tabType==1?'active':''"
                       @click="setTab(1)">在线作业<i></i></p>
                    <p :class="tabType==2?'active':''"
                       @click="setTab(2)">配套报纸</p>
                </div>
                <div v-if="loading">
                    <div class="content-wrap"
                         v-if="tabType==1">
                        <div class="taskList"
                             v-if="taskData && taskData.length"
                             v-for="(task,index) in taskData">
                            <div v-if="taskData[index].year_month!=''"
                                 class="date">
                                {{taskData[index].year_month}}
                            </div>
                            <!--检查作业-->
                            <div class="con_box"
                                 :class="[task.status == '3'?'con_check':'']">
                                <div class="box_top">
                                    <div class="box_left">
                                        <h3>{{task.class_name}}<i :class="[task.sid==21||task.sid==22||task.sid==23?'icon-sx':task.sid==91||task.sid==92?'icon-yy':task.sid==51?'icon-yw':task.sid==11||task.sid==14?'icon-sf':task.sid==12?'icon-bc':task.sid==24?'icon-wq':'icon-mx']"></i>
                                        </h3>
                                        <p class="box_left_time">截止：{{task.end_string}}</p>
                                        <p class="box_left_num">完成：<i>{{task.has_done_stu}}</i>/{{task.stu_num}}</p>
                                        <table></table>
                                    </div>
                                    <div class="box_right">
                                        <div v-if="task.status == '3'"
                                             @click="toDetail(task)">
                                            <p class="begTime">{{task.start_string}}</p>
                                            <p class="check">检查作业</p>
                                        </div>
                                        <div v-else-if="task.status == '1'">
                                            <p class="begTime">{{task.start_string}}</p>
                                            <p class="cancel"
                                               @click.stop="cancel(task.id, index, task.unit_class_id, true)">取消</p>
                                        </div>
                                        <div v-else-if="task.status == '2'"
                                             @click="toDetail(task)">
                                            <p class="begTime">{{task.start_string}}</p>
                                            <p class="statu1"><i>进行中</i><span class="view"></span></p>
                                        </div>
                                        <div v-else-if="task.status == '4'"
                                             @click="toDetail(task)">
                                            <p class="begTime">{{task.start_string}}</p>
                                            <p class="statu4"><i>已检查</i><span class="view"></span></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="box_bottom">
                                    <div class="box_bottom_left">{{task.task_name}}</div>
                                    <div class="box_bottom_right"><span class="cancel_btn"
                                              v-if="task.status!='1'"
                                              @click="cancel(task.id, index, task.unit_class_id)"><span>撤销</span><span class="cancel_icon"></span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="notask"
                             v-if="taskData.length==0">
                            <!-- <p><span class="icon-meiyoufabushijuan"></span></p> -->
                            <!-- <p class="up">您还没有发布过作业哟</p> -->
                            <!-- <p class="down">请先去给学生布置一个作业吧!</p> -->
                            <!-- <a class="settask" @click="settask">布置作业</a> -->
                            <p>暂无作业</p>
                        </div>
                    </div>

                    <div v-if="tabType==2">
                        <paperXCP></paperXCP>
                    </div>
                </div>
                <noResouse :type='1'
                           v-else-if='!taskData.length && loading'></noResouse>
                <div class="more">
                    <more-Loading v-show='moreLoading'></more-Loading>
                </div>
            </template>
            <template>
                <!-- <loadingS></loadingS> -->
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { mapState } from "vuex";
import headers from 'COMPONENTS/base/header.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
import moreLoading from 'COMPONENTS/moreLoading.vue';
import paperXCP from 'VIEWS/activity/xcpTea/hnPaper.vue';
export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            titles: "作业列表",
            loading: false,
            taskData: [],
            taskId: "",
            page: 1,
            firstPage: 1,
            num: 0,
            loadMoreTimer: null,//上拉加载定时器
            loadOver: false,//上拉加载加锁
            flag: true,
            token: localStorage.getItem('Tbkt-Token'),
            moreLoading: false,
            sids: [],
            myScroll: '',
            timeoutId: null,
            timeoutHeight: null,
            tabType: 1,
        }
    },
    async created () {
        await this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
            if (res.data.response === 'ok') {
                let r = res.data.data;
                localStorage.setItem('info', JSON.stringify(r));
                let unit = r.units;
                unit.forEach(u => {
                    if (u.sid == 51 || u.sid == 21 || u.sid == 22) {
                        this.sids.push(u.sid);
                    }
                });
            }
        })
        await this.getList();
        window.addEventListener('scroll', this.loadMore, false);


    },
    mounted () {
        // this.loadMore()
    },
    destroyed () {
        clearInterval(this.loadMoreTimer);
        window.removeEventListener('scroll', this.loadMore, false);

    },
    methods: {
        loadMore (e) {
            if (this.tabType == 2) {
                return false;
            }
            clearTimeout(this.timeoutHeight)
            this.timeoutHeight = setTimeout(() => {
                this.loadMoreTimer && clearTimeout(this.loadMoreTimer);
                this.loadMoreTimer = setTimeout(() => {
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                    if (scrollTop && (window.innerHeight + scrollTop >= this.$refs.myScroll.offsetHeight - 20)) {
                        clearTimeout(this.timeoutId)
                        this.timeoutId = setTimeout(() => {
                            this.$nextTick(() => {
                                if (!this.loadOver) {
                                    this.moreLoading = true;
                                    this.getList();
                                }
                            })
                        }, 100)
                    }
                }, 500)
            }, 100)

        },
        setTab (index) {
            this.tabType = index;
        },
        getList () {
            let that = this;
            let data = {
                p: that.page
            }
            //H5作业列表过滤掉课外活动
            if (!this.inApp) {
                data.is_h5 = 1
            }
            that.$http.post(API_URL_TASK_API + '/public/task/tea/list', data).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    if (res.data.length) {
                        let show = 0;
                        if (res.data.length) {
                            res.data.forEach((item) => {
                                item.page = that.page;
                            })
                            that.taskData = that.taskData.concat(res.data);
                            that.page++;
                            let month = that.taskData[0].year_month;
                            let school = that.taskData[0].school_name;
                            that.taskData.forEach(function (task, index) {
                                if (index > 0) {
                                    //相同月份只显示第一个
                                    if (!task.year_month || task.year_month == month) {
                                        task.year_month = ""
                                    } else {
                                        month = task.year_month
                                    }
                                    if (task.school_name == school || school == "") {
                                        show++;
                                    }
                                    return show;
                                }
                            });
                        }
                        if (show == that.taskData.length) {
                            //相同学校不显示
                            that.taskData.forEach(function (task, index) {
                                task.school_name = ""
                            })
                        };
                    } else {
                        this.loadOver = true;
                        if (this.page >= 1) {
                            layer.tips('已加载全部内容');
                        }
                    }
                    that.moreLoading = false;
                    that.loading = true;
                }
            })
        },
        toDetail (task) {//检查作业
            //console.log(task)
            this.$store.commit('setTabtype', 1)
            if (task.sid === 21 || task.sid === 22) {
                let sid = task.sid;
                let classid = task.unit_class_id;
                let taskid = task.id;
                let taskType = task.task_type;//区分：1课前2课后3课外
                let testType = task.test_type;
                // 课前
                // task_type  (1 知识点视频)
                // 课后
                //区分模块：(小学数学 1同步习题 2单元复习 3高频错题 4速算)
                //区分模块：(初中数学 1同步习题 2单元复习 3高频错题)
                if (taskType == 3) {//课外活动
                    if (this.inApp) {
                        this.appFunction("ys_task_result_kwhd", `${task.id},${task.unit_class_id}`)
                    } else {
                        layer.tips('请前往APP查看')
                    }
                } else if (testType == 12 || testType == 13 || testType == 14 || testType == 15 || testType == 16) { //这里填写需要跳转至个性化学习的task_type,12:同步习题，13:每周一测  14：单元复习  15:开学大检测  16：2022下半年期中检测
                    this.$router.push(`/personaLearning?sid=${task.sid}&taskId=${task.id}&classId=${task.unit_class_id}&taskType=${task.task_type}&testType=${task.test_type}&className=${encodeURIComponent(task.class_name)}`)
                } else {
                    this.$router.push('/taskdetial/' + sid + '/' + classid + '/' + taskid + '/' + taskType + '/' + testType + `?task_name=${task.task_name}&begin_date=${task.begin_date}`)
                }
            } else if (task.sid === 23) {
                //testType 1同步习题 2单元复习 3期中试卷 4期末试卷
                let { platform, app_version } = JSON.parse(localStorage.getItem('search'));
                window.location.href = `${VUE_URL_SX2}/tea/taskdetail/${task.unit_class_id}/${task.id}/${task.task_type}/${task.test_type}?task_name=${task.task_name}&begin_date=${task.begin_date}&tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`
            } else if (task.sid === 91 || task.sid === 92) {
                if (task.task_type == 3) {//课外活动
                    if (this.inApp) {
                        this.appFunction("ys_task_result_kwhd", `${task.id},${task.unit_class_id}`)
                    } else {
                        layer.tips('请前往APP查看')
                    }
                } else {
                    this.$router.push('/english/taskdetial/' + task.sid + '/' + task.id + '/' + task.task_type + '/' + task.unit_class_id + '?test_type=' + task.test_type + `&task_name=${task.task_name}&begin_date=${task.begin_date}`)
                }
            } else if (task.sid === 51) {
                if (task.task_type == 1) {
                    /***课前***/
                    this.$router.push('/chinese/inspect/beforedetial/' + task.unit_class_id + '/' + task.id + `?task_name=${task.task_name}&begin_date=${task.begin_date}`);
                } else if (task.task_type == 4) {
                    /***课外阅读***/
                    this.$router.push('/chinese/inspect/outread/' + task.unit_class_id + '/' + task.id + '?stu_num=' + task.has_done_stu + `&task_name=${task.task_name}&begin_date=${task.begin_date}`);
                } else if (task.task_type == 3) {
                    /***课外活动***/
                    if (this.inApp) {
                        this.appFunction("ys_task_result_kwhd", `${task.id},${task.unit_class_id}`)
                    } else {
                        layer.tips('请前往APP查看')
                    }
                } else if (task.task_type == 5) {
                    let { platform, app_version } = JSON.parse(localStorage.getItem('search'));
                    location.href = VUE_URL_QNYD + `/inspect/outread/${task.unit_class_id}/${task.id}?stu_num=${task.has_done_stu}&task_type=${task.task_type}&test_type=${task.test_type}&task_name=${task.task_name}&begin_date=${task.begin_date}&tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`;
                    return;
                } else if (task.test_type == 15 || task.test_type == 16 || task.test_type == 17 || task.test_type == 18) {//这里填写需要跳转至个性化学习的test_type 19:2022下半年期中检测
                    this.$router.push(`/personaLearning?sid=${task.sid}&taskId=${task.id}&classId=${task.unit_class_id}&taskType=${task.task_type}&testType=${task.test_type}&className=${encodeURIComponent(task.class_name)}`)
                } else {
                    /***课后***/
                    this.$router.push('/chinese/inspect/taskdetial/' + task.unit_class_id + '/' + task.id + '/' + task.task_type + '/' + task.test_type + `?task_name=${task.task_name}&begin_date=${task.begin_date}`)
                }
            } else if (task.sid == 11 || task.sid == 12 || task.sid == 13 || task.sid == 14) {
                this.$router.push('/qualityStation/taskDetail/' + task.unit_class_id + '/' + task.id + '?test_type=' + task.test_type + `&task_name=${task.task_name} &begin_date=${task.begin_date} &sid=${task.sid}&class_name=${task.class_name}`);
            } else if (task.sid == 24) {
                this.$router.push('/weiqi/taskDetail/' + task.unit_class_id + '/' + task.id + '?test_type=' + task.test_type + `&task_name=${task.task_name}&begin_date=${task.begin_date}&sid=${task.sid}&class_name=${task.class_name}`);
            }
        },
        settask () {//布置作业
            let subject = this.$route.params.subject;
            this.$router.push('/setBook/' + subject)
        },
        //删除作业
        cancel (taskid, taski, classid, flag) {
            let contentText = '';
            if (flag) {
                contentText = '是否要取消该作业? 取消后学生将不再收到该条作业，同时该条作业将被删除。';
            } else {
                contentText = '将删除本次作业，学生也无法再看到，确定要撤销吗？';
            }
            let that = this;
            layer.open({
                title: '提示',
                diff: 'tea',
                content: contentText,
                btn: ['确定', '取消'],
                yes: function (index) {
                    that.$http.post(API_URL_TASK_API + "/public/task/cancel", {
                        "message_id": taskid,
                        "unit_class_id": classid
                    }).then(res => {
                        res = res.data;
                        if (res.response == "ok") {
                            if (that.taskData[taski].year_month && that.taskData[taski + 1] && !that.taskData[taski + 1].year_month) {
                                that.taskData[taski + 1].year_month = that.taskData[taski].year_month;
                            }
                            that.taskData.splice(taski, 1);
                            if (flag) {
                                layer.open({
                                    content: '已取消',
                                    skin: 'msg',
                                    time: 2
                                });
                            }
                        }
                    });
                    layer.close(index);
                }
            });
        },

    },
    components: {
        headers,
        loadingS,
        noResouse,
        moreLoading,
        paperXCP
    },
    beforeRouteEnter (to, from, next) {
        let tab = 1;
        if (from.path.indexOf('hnPaper/chapter') > -1) {
            tab = 2
        };
        next(vm => {
            vm.tabType = tab;
        });
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.more {
    margin-top: 1.25rem;
}
.task-list {
    // height: 100vh;
    // overflow-y: hidden;
    .myScroll {
        min-height: 101vh;
        overflow-y: scroll;
    }
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: -0.5rem;
            left: 0.5rem;
        }
    }
    .img {
        width: 100%;
        height: 200px / $ppr;
        img {
            position: fixed;
            top: 96px / $ppr;
            left: 0;
            right: 0;
            width: 100%;
            display: block;
            height: 200px / $ppr;
            z-index: 8;
        }
    }
    .content-wrap {
        padding: 0 24px / $ppr;
        /* *
      未布置作业
      **/
        .notask {
            text-align: center;
            margin-top: 400px / $ppr;
            span {
                color: $c-litgray;
                font-size: 130px / $ppr;
                margin-bottom: $w;
            }
            .up {
                font-size: $lg;
                margin: $w 0;
            }
            .down {
                color: $c-light;
                font-size: $lt;
            }
            .settask {
                display: block;
                width: 400px / $ppr;
                height: 80px / $ppr;
                line-height: 80px / $ppr;
                background: $c-theme;
                color: $c-header;
                font-size: $lg;
                text-align: center;
                margin: 30px / $ppr auto;
                border-radius: 40px / $ppr;
            }
        }
        /**
      列表盒子
      **/
        .taskList {
            .date {
                margin-top: 40px / $ppr;
                margin-bottom: 24px / $ppr;
                font-size: $lt;
                color: #999;
            }
            .con_box {
                width: 672px / $ppr;
                //height: 314px/$ppr;
                margin: 0 auto;
                border-radius: 10px / $ppr;
                background-color: $c-fbg;
                margin-bottom: 24px / $ppr;
            }
            .con_check {
                background-color: #fff9e6;
            }

            .box_top {
                overflow: hidden;
                width: 625px / $ppr;
                //height: 222px/$ppr;
                border-bottom: 1px / $ppr solid #e8e8e8;
                margin: 0 auto;
                .box_left {
                    width: 390px / $ppr;
                    //height: 192px/$ppr;
                    float: left;
                    h3 {
                        //height: 84px/$ppr;
                        //line-height: 84px/$ppr;
                        margin-top: 40px / $ppr;
                        margin-bottom: 32px / $ppr;
                        font-size: 36px / $ppr;
                        color: #333;
                        i {
                            display: inline-block;
                            margin-left: 10px / $ppr;
                            width: 38px / $ppr;
                            height: 38px / $ppr;
                            vertical-align: text-top;
                            &.icon-sx {
                                background: url("./img/icon-sx.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                            &.icon-yy {
                                background: url("./img/icon-yy.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                            &.icon-yw {
                                background: url("./img/icon-yw.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                            &.icon-sf {
                                background: url("./img/icon-sf.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                            &.icon-bc {
                                background: url("./img/icon-bc.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                            &.icon-mx {
                                background: url("./img/icon-mx.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                            &.icon-wq {
                                background: url("./img/icon-wq.png") 0 0
                                    no-repeat;
                                background-size: 100% 100%;
                                margin-top: 0.12rem;
                            }
                        }
                    }
                    .box_left_time {
                        //height: 50px/$ppr;
                        //line-height: 28px/$ppr;
                        margin-bottom: 24px / $ppr;
                        font-size: 28px / $ppr;
                        color: #333;
                    }
                    .box_left_num {
                        color: #333;
                        margin-bottom: 32px / $ppr;
                        font-size: 30px / $ppr;
                        i {
                            color: #ff6600;
                        }
                    }
                }
                .box_right {
                    width: 235px / $ppr;
                    height: 192px / $ppr;
                    float: left;
                    .begTime {
                        text-align: right;
                        font-size: 24px / $ppr;
                        color: #ccc;
                        margin-top: 50px / $ppr;
                        margin-bottom: 20px / $ppr;
                        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        -webkit-tap-highlight-color: transparent;
                    }
                    .cancel {
                        width: 137px / $ppr;
                        height: 50px / $ppr;
                        border-radius: 30px / $ppr;
                        background: #5e89ef;
                        line-height: 50px / $ppr;
                        text-align: center;
                        font-size: 22px / $ppr;
                        color: #fff;
                        float: right;
                    }
                    .statu1 {
                        margin-top: 0.36rem;
                        float: right;
                        i {
                            font-size: 30px / $ppr;
                            color: #ff6600;
                            margin-top: -10px / $ppr;
                        }
                        span {
                            margin-left: 24px / $ppr;
                            margin-top: 10px / $ppr;
                            float: right;
                            width: 16px / $ppr;
                            height: 29px / $ppr;
                            background: url("./img/icon_next.png") no-repeat;
                            background-size: 100%;
                        }
                    }
                    .statu4 {
                        margin-top: 0.36rem;
                        float: right;
                        i {
                            font-size: 30px / $ppr;
                            color: #ccc;
                            margin-top: -10px / $ppr;
                        }
                        span {
                            margin-left: 24px / $ppr;
                            margin-top: 5px / $ppr;
                            float: right;
                            width: 16px / $ppr;
                            height: 29px / $ppr;
                            background: url("./img/icon_next.png") no-repeat;
                            background-size: 100%;
                        }
                    }
                }
            }

            .box_bottom {
                width: 625px / $ppr;
                margin: 0 auto;
                font-size: 24px / $ppr;
                height: 86px / $ppr;
                line-height: 86px / $ppr;
                color: #999;
                display: flex;
                .box_bottom_left {
                    flex: 1;
                    text-align: left;
                }
                .box_bottom_right {
                    flex: 1;
                    text-align: right;
                    overflow: hidden;
                    word-wrap: normal;
                    word-break: keep-all;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    .cancel_btn {
                        width: 90px / $ppr;
                        display: inline-block;
                        height: 86px / $ppr;
                        cursor: pointer;
                        span {
                            float: right;
                        }
                        .cancel_icon {
                            display: inline-block;
                            width: 29px / $ppr;
                            height: 28px / $ppr;
                            background-size: 100% 100%;
                            background-image: url("./img/cancel.png");
                            margin-right: 8px / $ppr;
                            margin-top: 28px / $ppr;
                        }
                    }
                }
            }

            .check {
                width: 172px / $ppr;
                height: 50px / $ppr;
                float: right;
                line-height: 50px / $ppr;
                text-align: center;
                border-radius: 30px / $ppr;
                color: #fff;
                font-size: 24px / $ppr;
                background-color: #ff6600;
            }

            .firstLoad {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100px / $ppr;
                height: 100px / $ppr;
                margin-top: -50px / $ppr;
                margin-left: -50px / $ppr;
            }
        }
    }
}
.uptip {
    display: none;
    padding: 22px / $ppr 24px / $ppr;
    font-size: 30px / $ppr;
    line-height: 50px / $ppr;
    color: #ff6600;
    background-color: #fffae4;
}
.tab {
    // line-height:96px/$ppr;
    // height:96px/$ppr;
    background: #fff;
    width: 100%;
    &.bb {
        border-bottom: 1px / $ppr solid #f0f0f0;
    }
    p {
        width: 50%;
        float: left;
        text-align: center;
        font-size: 30px / $ppr;
        font-weight: 600;
        line-height: 64px / $ppr;
        height: 64px / $ppr;
        padding: 16px / $ppr 0;
        position: relative;
        i {
            display: block;
            width: 1px / $ppr;
            height: 64px / $ppr;
            background: #f0f0f0;
            position: absolute;
            top: 16px / $ppr;
            right: 0;
            // border-right:1px/$ppr solid #f0f0f0;
        }
    }
    .active {
        color: #5e89ef;
    }
    .active:before {
        content: "";
        display: block;
        height: 6px / $ppr;
        width: 150px / $ppr;
        background: #5e89ef;
        border-radius: 3px / $ppr;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -75px / $ppr;
    }
}
</style>
